import { Stack }               from "@mantine/core";
import { Table }               from "@mantine/core";
import { Loader }              from "@mantine/core";
import dayjs                   from "dayjs";
import { useEffect, useState } from "react";

import Typography from "_components/atoms/typography";
import useStyles  from "_styles/pages/growthDashboard/table";

const GrowthTable = ( { tableData, loading, tab: tabIndex } ) => {
	const [ formattedData, setFormattedData ] = useState ( [] );

	const secondHeaderColumnMap = { downloads: "Downloads", signups: "Sign Ups", d1Data: "Retention Percentage" };

	const columns = [
		{ field: "date", headerName: "Date", flex: 1, headerAlign: "center", align: "center" },
		{ field: "count", headerName: secondHeaderColumnMap[tabIndex], flex: 1, headerAlign: "center", align: "center" }
	];

	const { classes } = useStyles ( undefined, { name: "styles" } );

	useEffect ( () => {

		formatData ( tableData );
	}, [ tableData ] );

	const formatData = data => {
		const result = Array.isArray ( data ) && data?.map ( val => {
			return { date: dayjs ( val.date ).format ( "D MMM" ), count: val.count };
		} );

		if ( !result )
			return;

		setFormattedData ( result );
	};

	if ( loading )
		return <Loader />;

	if ( !formattedData.length ) {
		return (
			<Stack alignItems = "center"
				height           = "100%"
				justifyContent   = "center"
			>
				<Typography
					component = { "h4" }
					title     = "No data for now, please check again later"
				/>
			</Stack>
		);
	}

	const head = columns.map ( element => (
		<th key = { element.field }
			style  = { { textAlign: "center" } }
		>
			{element.headerName}
		</th>
	) );

	const rows = formattedData.map ( ( element, index ) => (
		<tr key = { index }>
			<td style = { { textAlign: "center" } }>
				{element.date}
			</td>

			<td style = { { textAlign: "center" } }>
				{element.count}
			</td>
		</tr>
	) );

	return (
		<div className = { classes.tableContainer }>
			<Table style = { { tableLayout: "fixed" } }>
				<thead>
					<tr>
						{head}
					</tr>
				</thead>

				<tbody>
					{rows}
				</tbody>
			</Table>

		</div>
	);
};

export default GrowthTable;
